/**
 * React Native Share stub for web
 * Provides mock implementation for native share functionality
 */

declare const window: any;
declare const navigator: any;

// Mock TurboModule registry
const TurboModuleRegistry = {
  getEnforcing: (name: string) => {
    // Return mock native modules
    return {
      share: async (content: any) => {
        if (typeof window !== 'undefined' && navigator.share) {
          try {
            await navigator.share({
              title: content.title || 'Share',
              text: content.message || '',
              url: content.url || window.location.href,
            });
          } catch (err) {
            // Sharing cancelled
          }
        } else {
          // Fallback: copy to clipboard or open in new window
          if (content.url) {
            window.open(content.url, '_blank');
          }
        }
        return null;
      },
    };
  },
};

// Mock NativeRNShare
const NativeRNShare = {
  share: async (content: any) => {
    if (typeof window !== 'undefined' && navigator.share) {
      try {
        await navigator.share({
          title: content.title || 'Share',
          text: content.message || '',
          url: content.url || window.location.href,
        });
      } catch (err) {
        // Sharing cancelled
      }
    } else {
      // Fallback
      if (content.url) {
        window.open(content.url, '_blank');
      }
    }
    return null;
  },
};

export { TurboModuleRegistry, NativeRNShare };
export default {
  share: async (content: any) => {
    if (typeof window !== 'undefined' && navigator.share) {
      try {
        await navigator.share({
          title: content.title || 'Share',
          text: content.message || '',
          url: content.url || window.location.href,
        });
      } catch (err) {
        // Sharing cancelled
      }
    } else {
      if (content.url) {
        window.open(content.url, '_blank');
      }
    }
    return null;
  },
};
